export class Event extends EventTarget {
    
    fireEvent(event, value = '') {
        let _event = new CustomEvent(event, { detail: value });
        this.dispatchEvent(_event);
    };
    
}
